import { HStack } from '@direct-frontend/components';
import { StepStub } from './components/Step';
import styles from './OnboardingStepper.module.css';

export function OnboardingStepperStub() {
    return (
        <HStack gap="8" className={styles.stepper}>
            {new Array(6).fill(null).map((_, index) => (
                <StepStub key={index} />
            ))}
        </HStack>
    );
}
